export default __webpack_public_path__ + "images/c44004cd697c3a7c52dc31d7aad27f73.png";